import React, { useEffect, useState } from "react";
var IPBasedLoginContext = /*#__PURE__*/ React.createContext(undefined);
export var IPBasedLoginContextProvider = function IPBasedLoginContextProvider(_ref) {
    var children = _ref.children;
    var _useState = useState(undefined), login = _useState[0], setLogin = _useState[1];
    useEffect(function () {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', function () {
            if (xhr.responseText) {
                var parsedResponseText = JSON.parse(xhr.responseText);
                if (parsedResponseText && parsedResponseText.status) {
                    setLogin(parsedResponseText.name);
                }
            }
        });
        xhr.open('GET', 'https://europe-west1-makroskop-b14f3.cloudfunctions.net/ipBasedLogin', true);
        xhr.send();
    }, []);
    return /*#__PURE__*/ React.createElement(IPBasedLoginContext.Provider, {
        value: login
    }, children);
};
export default IPBasedLoginContext;
